import React from "react";

const Home = () => {
  return (
    <section className="home" id="home">
      <div className="home-container bd-grid">
        <div>
          <h1 className="home-title">
            He
            <br />
            LLO.
          </h1>
          <h1 className="home-subtitle">
            I'M <strong className="purple">MANISH KUMAR</strong>
          </h1>
        </div>
        <img className="home-img" src="home-main.svg" alt="" />
      </div>
    </section>
  );
};

export default Home;
